




























































































import { Component, Prop } from "vue-property-decorator";
import moment from "moment";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { TYPES_MESSAGES } from "@/resources/constants/messages";
import { i18n } from "@/resources/locales";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "message-component",
})
export default class MessageComponent extends mixins(
  UserValidator,
  NotificationEvent,
  Plans
) {
  @Prop(String) readonly content: string;
  @Prop(String) readonly date: string;
  @Prop(Boolean) readonly local: boolean;
  @Prop(String) readonly userName: string;
  @Prop(String) readonly metadata: string;
  @Prop(String) readonly messageId: string;
  CHAT_TYPE = CHAT_TYPE;
  PLAN= PLAN;
  get dateFormat(): string {
    return moment(this.date).format("HH:mm");
  }

  convertUrlToLink(text: string): string {
    /* if (this.isHtml(text)) return text.toString();*/
    // URLs starting with http://, https://, or ftp://
    const replacePattern1 =
      /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
    let replacedText = text.replace(
      replacePattern1,
      '<a href="$1" target="_blank">$1</a>'
    );

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    const replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '<a href="http://$2" target="_blank">$2</a>'
    );

    // Change email addresses to mailto:: links.
    const replacePattern3 =
      /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(
      replacePattern3,
      '<a href="mailto:$1">$1</a>'
    );
    const div = document.createElement("p");

    replacedText = replacedText.replace("/*?/", "");
    replacedText = replacedText.replace("/*>/", "");
    replacedText = replacedText.replace("/*g/", "");
    div.innerHTML = replacedText;
    return replacedText;
  }
  isHtml(text: string): boolean {
    const regex = /<[^>]*>/;
    return regex.test(text);
  }
  isReaction(): boolean {
    const metadata = JSON.parse(this.metadata);
    return metadata.messageType === TYPES_MESSAGES.REACTION;
  }
  isHandUp(): boolean {
    const metadata = JSON.parse(this.metadata);
    return metadata.messageType === TYPES_MESSAGES.HAND_UP;
  }
  unicodeToEmoji(unicode: string): string {
    if (!unicode) return "";

    unicode = unicode.toLowerCase().replace("u+", "");

    let emoji: string;
    if (
      unicode == null ||
      unicode == "" ||
      unicode == "null" ||
      unicode == "delete_emoji"
    )
      emoji = "";
    else emoji = String.fromCodePoint(parseInt(unicode, 16));

    return emoji;
  }
  pinMessage(): void {
    if (!this.activeOptionPlan(PLAN.PIN_MESSAGES)) return;
    const metadata = JSON.parse(this.metadata);
    const space = this.$store.getters["SpaceStore/getSpace"];
    let data = null;
    data = {
      space: space.id,
      messageId: this.messageId,
    };
    if (metadata.roomId)
      data = {
        room: metadata.roomId,
        messageId: this.messageId,
      };
    this.$store.dispatch("ChatStore/pinMessageAction", {
      data: data,
      callback: () => {
        const pinnedMessagesLength =
          this.$store.getters["ChatStore/getPinnedMessagesLength"];
        this.$store.dispatch(
          "ChatStore/setPinnedMessagesLengthAction",
          parseInt(pinnedMessagesLength) + 1
        );
        this.onDefault(
          "",
          this.$i18n.t("notifications.descriptions.pinnedMessage")
        );
      },
    });
  }
  get chatType(): string {
    return this.$store.getters["ChatStore/getChatType"];
  }
  getMessageType() {
    const metadata = JSON.parse(this.metadata);
    if (
      this.content.includes("/*?/") ||
      metadata.messageType === TYPES_MESSAGES.QUESTION
    )
      return "question";
    if (
      this.content.includes("/*>/") ||
      metadata.messageType === TYPES_MESSAGES.PAPER_PLANE
    )
      return "paperplane";
    if (
      this.content.includes("/*g/") ||
      metadata.messageType === TYPES_MESSAGES.ANNOUNCEMENT
    )
      return "global";
  }
}
